"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePvs = exports.pvsData = exports.resultsDefinition = void 0;
const functions_1 = require("../functions");
const property_1 = require("@genesys/property");
// Every value CoilPro returns for this coil, under CoilPro's own names, so one vocabulary runs
// from the DLL through the schema to the translation key. Errors and warnings are comma-joined
// strings; a coil can calculate successfully and still warn, so an empty warnings cell is the
// only clean result.
exports.resultsDefinition = [
    {
        sortNo: 10,
        propertyName: "errors"
    },
    {
        sortNo: 20,
        propertyName: "warnings"
    },
    {
        sortNo: 30,
        propertyName: "airpressuredropdry"
    },
    {
        sortNo: 40,
        propertyName: "airtotalheat"
    },
    {
        sortNo: 50,
        propertyName: "steamtotalheat"
    },
    {
        sortNo: 60,
        propertyName: "totalheat"
    },
    {
        sortNo: 70,
        propertyName: "temperatureout"
    },
    {
        sortNo: 80,
        propertyName: "humidityout"
    },
    {
        sortNo: 90,
        propertyName: "pressureout"
    },
    {
        sortNo: 100,
        propertyName: "flow"
    },
    {
        sortNo: 110,
        propertyName: "airvelocity"
    },
    {
        sortNo: 120,
        propertyName: "airstandardvelocity"
    },
    {
        sortNo: 130,
        propertyName: "sensibletotalcapacityratio"
    },
    {
        sortNo: 140,
        propertyName: "marginal"
    },
    {
        sortNo: 150,
        propertyName: "gaugesteampressure"
    },
    {
        sortNo: 160,
        propertyName: "steammassflow"
    },
    {
        sortNo: 170,
        propertyName: "steamvelocity"
    }
];
const pvsData = (result) => ({
    errors: result.errors,
    warnings: result.warnings,
    airpressuredropdry: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airPressureDropDry)),
    airtotalheat: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airTotalHeat)),
    steamtotalheat: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.steamTotalHeat)),
    totalheat: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.totalHeat)),
    temperatureout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.temperatureOut)),
    humidityout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.humidityOut)),
    pressureout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.pressureOut)),
    flow: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.flow)),
    airvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airVelocity)),
    airstandardvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airStandardVelocity)),
    sensibletotalcapacityratio: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.sensibleTotalCapacityRatio)),
    marginal: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.marginal)),
    gaugesteampressure: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.gaugeSteamPressure)),
    steammassflow: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.steamMassFlow)),
    steamvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.steamVelocity)),
});
exports.pvsData = pvsData;
const makePvs = (result) => (0, functions_1.collectResults)((0, exports.pvsData)(result));
exports.makePvs = makePvs;
//# sourceMappingURL=result-definition.js.map